import { AgGridVue } from 'ag-grid-vue3'
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { watch, ref, computed } from 'vue'
import { useStore } from 'vuex'

ModuleRegistry.registerModules([AllCommunityModule]);

export default {
    name: 'AgGrid',
    components: {
        AgGridVue
    },
    props: {
        rowData: {
            type: Array,
            required: true
        },
        columnDefs: {
            type: Array,
            required: true
        },
        isPagination: {
            type: Boolean,
            default: false,
            required: false
        },
        paginationPageSize: {
            type: Number,
            required: false
        },
        selectedPage: {
            type: Number,
            required: false
        },
        noRowsToShowText: {
            type: String,
            required: false,
            default: 'No results found. Try adjusting your search term or filters.'
        },
        icons: {
            type: Object,
            required: false,
            default: {}
        },
        components: {
            type: Object,
            required: false,
            default: () => ({})
        },
        isRowSelectable: {
            type: Function,
            required: false,
            default: undefined
        },
        getRowClass: {
            type: Function,
            required: false,
            default: null
        },
        enableCellTextSelection: {
            type: Boolean,
            required: false,
            default: false
        },
        getRowId: {
            type: Function,
            required: false,
            default: undefined
        }
    },
    setup(props, { emit }) {
        const gridApi = ref()
        const store = useStore()
        const navBarStatus = computed(() => store.getters['inventoryingestion/getNavBarOpen'])
        const rowSelectionObj = computed(() => {
            return props.isRowSelectable ? {
                mode: 'multiRow',
                isRowSelectable: props.isRowSelectable,
                headerCheckbox: true,
                enableClickSelection: false,
            } : undefined
        })

        const getRowId = props.getRowId

        const onCellValueChanged = event => {
            emit('sis:cell-valueUpdated', event)
        }

        const onCellEditStart = event => {
            emit('sis:cell-editStarted', event)
        }

        const onGridReady = params => {
            gridApi.value = params.api
            setTimeout(() => {
                params?.api?.sizeColumnsToFit() // Adjust column widths to fill the available width

                // Set data-qa-id for the header rows
                const headerElement = document.querySelector('.ag-header');
                if (headerElement) {
                    headerElement.setAttribute('data-qa-id', 'agGrid-header-row');
                }

                // Set data-qa-id for the data rows
                const allRows = gridApi.value.getRenderedNodes();
                allRows?.forEach((rowNode) => {
                    const rowElement = document.querySelector(`[row-id="${rowNode.id}"]`);
                    if (rowElement) {
                        // Add a custom attribute to each data row
                        rowElement.setAttribute('data-qa-id', 'agGrid-data-row');
                    }
                });
            }, 500)
            emit('sis:grid-api', gridApi.value)
        }

        const onRowDragEnd = (event) => {
            // After drag-and-drop operation, get the updated row order
            const rowCount = event.api.getDisplayedRowCount();
            const rowOrder = [];

            for (let i = 0; i < rowCount; i++) {
                const rowNode = event.api.getDisplayedRowAtIndex(i);
                rowOrder.push(rowNode.data); // Store the row data in the new order
            }
            emit('sis:row-drag-end', rowOrder)
        }

        const onSelectionChanged = () => {
            const selectedNodes = gridApi.value.getSelectedNodes()
            const selectedRows = selectedNodes?.map(node => node.data) // Get the row data of selected nodes
            emit('sis:selected-row', selectedRows)
        }

        const onSortChanged = event => {
            emit('sis:sort-changed', event)
        }

        const onRowClicked = event => {
            emit('sis:row-clicked', event)
        }

        watch(
            () => props.selectedPage,
            (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    gridApi.value?.paginationGoToPage(newVal - 1)
                }
            },
            { immediate: true, deep: true }
        )

        watch(
            () => navBarStatus.value,
            newData => {
                if (gridApi?.value) {
                    setTimeout(() => {
                        gridApi?.value?.sizeColumnsToFit()
                    }, 700)
                }
            },
            { deep: true, immediate: true }
        )

        return {
            onCellValueChanged,
            onGridReady,
            gridApi,
            onSortChanged,
            onRowDragEnd,
            onCellEditStart,
            onSelectionChanged,
            onRowClicked,
            rowSelectionObj,
            themeQuartz,
            getRowId,
        }
    }
}
